import React from 'react';
import useTranslation from '../../../../../Hooks/useTranslation';
import { MEDICAL_EXAMINATION_TRANSLATION_MAP } from '../../../Helpers/medicalExamination/medicalExaminationTranslationMap';
import styles from './DENTHistoryItemMedicalExamination.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { MedicalExamination } from '../../../../../graphql/graphql';

interface Props {
	item: MedicalExamination;
	onClick: () => void;
}

const DENTHistoryItemMedicalExamination = ({ item, onClick }: Props) => {
	const { t } = useTranslation();

	return (
		<div onClick={onClick} className={styles.title}>
			<span>{t(MEDICAL_EXAMINATION_TRANSLATION_MAP[item.type])}</span>
			{', '}
			<span>
				<FormattedMomentDate
					date={item.completedAt}
					format={DateFormat.DATE_TIME}
				/>
			</span>
			{', '}
			<span>{item.createdBy.profile?.fullName}</span>
		</div>
	);
};

export default DENTHistoryItemMedicalExamination;
